/**
 * Utility functions for API calls
 */

/**
 * Builds query string parameters from an object, filtering out empty values
 * @param params - Object containing parameters
 * @returns Query string (without the '?' prefix)
 */
export const buildQueryString = (params: Record<string, any>): string => {
  const queryParams = new URLSearchParams();
  
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      // Handle arrays and objects by JSON stringifying them
      if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
        queryParams.append(key, JSON.stringify(value));
      } else {
        queryParams.append(key, value.toString());
      }
    }
  });
  
  return queryParams.toString();
};

/**
 * Builds a complete URL with query parameters
 * @param baseUrl - Base URL
 * @param params - Query parameters object
 * @returns Complete URL with query string
 */
export const buildApiUrl = (baseUrl: string, params: Record<string, any>): string => {
  const queryString = buildQueryString(params);
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

/**
 * Creates a standardized API response handler
 * @param response - API response
 * @returns Extracted data from response
 */
export const handleApiResponse = (response: any) => {
  return response.data?.data;
};

/**
 * Creates a standardized error handler for API calls
 * @param error - Error object
 * @param context - Context for error logging
 */
export const handleApiError = (error: any, context: string) => {
  console.error(`Error in ${context}:`, error);
  throw error;
};
